import {
  ScanBarcode,
  RefreshCw,
  BadgeCheck,
  FileText,
  History,
  BarChart3,
  Languages,
} from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal } from "./Reveal";

const ICONS = { ScanBarcode, RefreshCw, BadgeCheck, FileText, History, BarChart3, Languages };

export default function Features() {
  const { t } = useLang();
  return (
    <section id="que-incluye" className="border-t lp-hairline bg-[#0c0c0f]">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 py-20 sm:py-32">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#f5a623]">
            {t.features.kicker}
          </p>
          <h2 className="mt-3 font-black tracking-tighter text-3xl sm:text-4xl max-w-xl">
            {t.features.title}
          </h2>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {t.features.cards.map((card, i) => {
            const Icon = ICONS[card.icon];
            return (
              <Reveal
                key={card.title}
                delay={Math.min(i * 0.06, 0.3)}
                className={i === 0 ? "sm:col-span-2 lg:col-span-1 lg:row-span-2" : ""}
              >
                <div
                  data-testid={`feature-card-${i}`}
                  className="group h-full rounded-2xl border lp-hairline bg-white/[0.02] p-6 sm:p-7 transition-colors duration-300 hover:border-[#f5a623]/40 hover:bg-[#f5a623]/[0.04]"
                >
                  <span className="inline-grid place-items-center w-11 h-11 rounded-xl bg-[#f5a623]/12 border border-[#f5a623]/25 text-[#f5a623]">
                    <Icon size={22} />
                  </span>
                  <h3 className="mt-5 text-lg font-bold tracking-tight">{card.title}</h3>
                  <p className="mt-2 text-sm text-[#a1a1aa] leading-relaxed">{card.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
